import React from 'react';
import { ProductCheck } from '.';
import { ProductItemProps } from '../../../../models/Product';
import { ServiceItemProps } from '../../../../models/Service';

export type useProductListCheckProps = {
  products: ProductCheck[];
  selectedService: ServiceItemProps | undefined;
  setProducts: (values: ProductCheck[]) => void;
  setProductList: (list: ProductItemProps[]) => void;
};

export const useProductListCheck = ({
  products,
  setProducts,
  setProductList,
  selectedService
}: useProductListCheckProps) => {
  function orderProductsByPriority(products: ProductItemProps[]) {
    return products.sort((product, product2) => {
      return Number(product.priority) - Number(product2.priority);
    });
  }

  React.useEffect(() => {
    if (selectedService) {
      const productsOrdered = orderProductsByPriority(selectedService.products);
      setProductList(productsOrdered);
    }
  }, []);

  function handleSelectProduct(product: ProductItemProps) {
    const newProducts = products.map(item => {
      if (item.id === product.id) return { ...item, selected: !item.selected };
      return item;
    });
    setProducts(newProducts);
  }
  return { handleSelectProduct };
};
